module.exports=[
  {
    "label": "Good",
    "range": "0-50"
  },
  {
    "label": "Moderate",
    "range": "51-100"
  },
  {
    "label": "Unhealthy for sensitive groups",
    "range": "101-150"
  },
  {
    "label": "Unhealthy",
    "range": "151-200"
  },
  {
    "label": "Very unhealthy",
    "range": "201-300"
  },
  {
    "label": "Hazardous",
    "range": "301-500"
  },
  {
    "label": "No data",
    "range": "n/a"
  }
]